import React from "react";
import moment from "moment-timezone";
import { DatePicker as AntdDatePicker } from "antd";

const DatePicker = ({
  defaultOpenValue,
  format = "DD/MM/YYYY",
  value,
  onChange,
  ...props
}) => (
  <AntdDatePicker
    placeholder={null}
    allowClear={false}
    {...props}
    defaultOpenValue={defaultOpenValue && moment(defaultOpenValue, format)}
    value={value && moment(value, format)}
    format={format}
    onChange={value => onChange(value.format(format))}
  />
);

export default DatePicker;
